import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=04c23cbe&"
import script from "./Investments.vue?vue&type=script&lang=js&"
export * from "./Investments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports